import React from 'react';
import {observable} from "mobx";

class Store {
  @observable showItemId = 'xszn';
}

export default new Store()
